import { useQuery } from '@tanstack/react-query';
import { getPatternDestinationAddresses } from 'src/backend/donations';

export default function useGetPatternDestinationAddresses(
  patternId,
  options = {}
) {
  return useQuery({
    queryKey: ['pattern-destination-addresses', patternId],
    queryFn: () => getPatternDestinationAddresses(patternId),
    refetchOnWindowFocus: false,
    ...options,
  });
}
